import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';

export const getPeopleVehicleRegistrations = async (ptsPersonID) => {
  const service = getService(ServiceName.RecordPersonVehicleRegistration);
  const response = await service.find({
    query: {
      ptsParentID: ptsPersonID,
      IsDeleted: false,
      $sort: { Created: -1 },
    },
  });
  return response?.data || response || [];
};

export const createVehicleRegistration = async (payload) => {
  const service = getService(ServiceName.CadPtsVehicleReg);
  const response = await service.create(payload);
  return response?.data || response;
};

export const updateVehicleRegistration = async (ptsRegistrationID, payload) => {
  const service = getService(ServiceName.CadPtsVehicleReg);
  const response = await service.patch(ptsRegistrationID, payload);
  return response?.data || response;
};

export const deleteVehicleRegistration = async (ptsRegistrationID) => {
  const service = getService(ServiceName.CadPtsVehicleReg);
  const response = await service.remove(ptsRegistrationID);
  return response?.data || response;
};

export const getVehicleRegistrations = async (ptsVehicleID) => {
  const service = getService(ServiceName.CadPtsVehicleReg);
  const response = await service.find({ query: { ptsVehicleID } });
  return response?.data || response || [];
};

export const createVehicle = async (payload) => {
  const service = getService(ServiceName.CadSearchVehicles);
  const response = await service.create(payload);
  return response?.data || response;
};

export const getVehicleDetails = async (ptsVehicleID) => {
  const service = getService(ServiceName.CadPtsVehicle);
  const response = await service.get(ptsVehicleID);
  const rows = response?.data || response || [];
  return Array.isArray(rows) ? rows[0] : rows;
};

export const updateVehicleDetails = async (ptsVehicleID, payload) => {
  const service = getService(ServiceName.CadPtsVehicle);
  const response = await service.patch(ptsVehicleID, payload);
  return response?.data || response;
};

export const getVehicleTowingRecords = async (ptsVehicleID) => {
  const service = getService(ServiceName.CadVehicleTowing);
  const response = await service.find({ query: { ptsVehicleID } });
  return response?.data || response || [];
};

export const getPlaceVehicleRegistrations = async (ptsPlaceID) => {
  const service = getService(ServiceName.PtsVehicleReg);
  const response = await service.find({
    query: {
      ptsParentID: ptsPlaceID,
      PartyType: 'Place',
      IsDeleted: false,
      $sort: { Created: -1 },
    },
  });
  return response?.data || response || [];
};

export const getVehicleTowingRecord = async (ptsTowingID) => {
  const response = await getService(ServiceName.CadVehicleTowing).get(ptsTowingID);
  return response?.data || response;
};

export const saveVehicleTowingRecord = async (payload, ptsTowingID = null) => {
  const service = getService(ServiceName.CadVehicleTowing);
  const response = ptsTowingID
    ? await service.patch(ptsTowingID, payload)
    : await service.create(payload);
  return response?.data || response;
};
